import { render } from "./LandingPageCaricamento.vue?vue&type=template&id=0866b272&scoped=true"
import script from "./LandingPageCaricamento.vue?vue&type=script&lang=js"
export * from "./LandingPageCaricamento.vue?vue&type=script&lang=js"

import "./LandingPageCaricamento.vue?vue&type=style&index=0&id=0866b272&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Desktop/Progetti/ask_landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0866b272"]])

export default __exports__